import { memo } from 'react';

import { Checkbox } from '@clubspark-react/ui';
import { Menu, MenuItem } from '@mui/material';
import { type Column } from '@tanstack/react-table';

import NewCheckBoxIcon from 'assets/icons/icon-checkBox-medium.svg?react';
import { useStyles as usePopoverStyles } from 'components/menus/popoverMenu/styles';
import { noop } from 'utils/fnUtils';
import { firstCapital } from 'utils/scheduleUtils';

type ColumnsMenuClasses = 'root' | 'menuItem' | 'item' | 'label' | 'control' | 'disableToggle' | 'unCheckbox';

interface EnhancedColumnsMenuProps {
  allColumns: Column<any, unknown>[];
  anchorEl?: HTMLElement;
  classNames?: Partial<Record<ColumnsMenuClasses, string>>;
  customColumnsMenu?: boolean;
  disabledToggleColumns?: string[];
  onClose: () => void;
}

const EnhancedColumnsMenu: React.FC<React.PropsWithChildren<EnhancedColumnsMenuProps>> = ({
  allColumns,
  anchorEl,
  classNames,
  customColumnsMenu,
  disabledToggleColumns,
  onClose,
}) => {
  const { classes: popoverClasses } = usePopoverStyles();

  return (
    <Menu
      anchorEl={anchorEl}
      classes={{ list: classNames?.root }}
      className={popoverClasses.popoverCheckboxes}
      id="columns-popover"
      open={!!anchorEl}
      onClose={onClose}
    >
      {allColumns
        ?.filter((column) => column.id !== 'selection')
        .map((column) => {
          const isDisableToggle = disabledToggleColumns?.includes(column?.id);
          if (isDisableToggle) {
            column.toggleVisibility = noop;
          }

          return (
            <MenuItem
              key={column.id}
              className={classNames?.menuItem}
              id={column.id}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                column.getToggleVisibilityHandler()(e);
              }}
            >
              <Checkbox
                {...(customColumnsMenu && {
                  checkedIcon: <NewCheckBoxIcon />,
                  icon: <div className={classNames?.unCheckbox} />,
                })}
                {...column.columnDef}
                checked={column.getIsVisible()}
                className={isDisableToggle ? classNames?.disableToggle : classNames?.control}
                label={(column.columnDef.header || firstCapital(column.columnDef.id)) as string}
                value=""
              />
            </MenuItem>
          );
        })}
    </Menu>
  );
};

export default memo(EnhancedColumnsMenu);
